'use client';
import Chart from 'react-apexcharts';

const DefaultChartCompressor2 = ({ chartDataProps, chartType, regime }) => {
	const leitura = chartDataProps.leiturasCompressor;

	const options = {
		chart: {
			id: 'basic-line',
			type: 'line',
			dropShadow: {
				enabled: true,
				color: '#123',
				top: 18,
				left: 7,
				blur: 10,
				opacity: 0.5,
			},
			toolbar: {
				show: false,
				tools: {
					download: false,
					selection: false,
					zoom: true,
					zoomin: true,
					zoomout: true,
					pan: false,
					reset: true,
				},

			},
			animations: {
				enabled: false,
				easing: 'easeinout',
				speed: 800,
				animateGradually: {
					enabled: true,
					delay: 150,
				},
				dynamicAnimation: {
					enabled: true,
					speed: 350,
				},
			},
		},
		grid: {
			show: false,
			borderColor: '#40475D',
			strokeDashArray: 0,
		},
		stroke: {
			show: true,
			curve: 'smooth',
			lineCap: 'butt',
			width: 1.2,
			dashArray: 0,
		},
		states: {
			hover: {
				filter: 'none',
			},
		},
		markers: {
			size: 0,
		},
		xaxis: {
			type: 'datetime',
			position: 'bottom',
			labels: {
				formatter: function (val) {
					const date = new Date(val);
					return date.toLocaleTimeString('pt-BR', {
						hour: '2-digit',
						minute: '2-digit',
					});
				  }
,				show: true,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '12px',
					fontStyle: 'normal',
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		},
		yaxis: [{
			// title:"Eficiência",
			seriesName: 'Pressão de sucção',
			labels: {
				show: true,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '14px',
				},
				formatter: function (val) {
					const valor = val.toLocaleString('pt-BR', {
						maximumFractionDigits: 2,
					}) + ' bar';
					return valor;
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		},{
			// title:"valores",
			seriesName: 'Pressão de sucção',
			opposite:true,
			labels: {
				show: false,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '14px',
				},
				formatter: function (val) {
					const valor = val.toLocaleString('pt-BR', {
						maximumFractionDigits: 2,
					}) + ' bar';
					return valor;
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		},{
			// title:"valores",
			seriesName: 'Pressão de sucção',
			opposite:true,
			labels: {
				show: true,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '14px',
				},
				formatter: function (val) {

					const valor = val.toLocaleString('pt-BR', {
						maximumFractionDigits: 2,
					}) + ' bar';

					return valor;
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		},{
			// title:"valores",
			seriesName: 'Temperatura de sucção',
			opposite:true,
			labels: {
				show: true,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '14px',
				},
				formatter: function (val) {
					const valor = val.toLocaleString('pt-BR', {
						maximumFractionDigits: 2,
					}) + " ºC";
					return valor;
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		},{
			// title:"valores",
			seriesName: 'Temperatura de sucção',
			opposite:true,
			labels: {
				show: true,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '14px',
				},
				formatter: function (val) {
					const valor = val.toLocaleString('pt-BR', {
						maximumFractionDigits: 2,
					}) + " ºC";
					return valor;
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		}],
		tooltip: {
			theme: 'dark',
		},
		dataLabels: {
			enabled: false,
		},
		legend: {
			show: true,
			position: 'top',
			fontStyle: 'bold',
			fontColor: 'white',
			fontSize: '16px',
			labels: {
				colors: 'white',
				useSeriesColors: false,
			},
			onItemClick: {
				toggleDataSeries: true,
			},
			onItemHover: {
				highlightDataSeries: true,
			},
		},
	};


	const series = [
			{
				name: 'Pressão de sucção',
				data: leitura.map((leitura) => ([leitura.dataHora,leitura.pressaoSuccao])),
				yaxis: 0,
			},
			{
				name: 'Pressão descarga',
				data: leitura.map((leitura) => ([leitura.dataHora,leitura.pressaoDescarga])),
				yaxis: 0,
			},
			{
				name: 'Pressão óleo',
				data: leitura.map((leitura) => ([leitura.dataHora,leitura.pressaoOleoReservatorio])),
				yaxis: 0,
			},
			{
				name: 'Temperatura de sucção',
				data: leitura.map((leitura) => ([leitura.dataHora,leitura.temperaturaSuccao])),
				yaxis: 0,
			},
			{
				name: 'Temperatura de descarga',
				data: leitura.map((leitura) => ([leitura.dataHora,leitura.temperaturaDescarga])),
				yaxis: 0,
			},
		];


	if (!chartDataProps) return null;

	return (
		<div className="bg-transparent w-full h-full p-2">
			<Chart
				options={options}
				series={series}
				width="100%"
				height={320}
			/>
		</div>
	);
};

export default DefaultChartCompressor2;
